import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { ParentalGateService } from '../services/parental-gate.service';

/**
 * Protects parents-only pages (Kids category requirement), e.g. sign-in, which
 * collects an email/phone number. Passing the gate once is remembered for the
 * session. Subscription actions are gated individually (guardForSession).
 */
@Injectable({
  providedIn: 'root',
})
export class ParentalGateGuard implements CanActivate {
  constructor(private readonly parentalGateService: ParentalGateService, private readonly router: Router) {}

  async canActivate(): Promise<boolean | UrlTree> {
    if (await this.parentalGateService.requestForSession()) {
      return true;
    }
    // Stay on the current page; if the webview was opened directly on a gated
    // route there is no current page, so fall back to the intro.
    return this.router.navigated ? false : this.router.parseUrl('/intro');
  }
}
